// Window types for widget configuration
declare global {
  interface Window {
    WIDGET_CONFIG: {
      businessApiKey: string
      apiBaseUrl: string
      widgetConfig: {
        enabled_services?: string[]
        [key: string]: any
      }
      businessInfo: {
        id: string
        name: string
        slug: string
        [key: string]: any
      }
    }
    WIDGET_CONTEXT: {
      isPreview: boolean
      [key: string]: any
    }
  }
}

// Get widget configuration from Flask-injected globals
export function getWidgetConfig() {
  if (typeof window === 'undefined' || !window.WIDGET_CONFIG) {
    throw new Error('Widget configuration not found')
  }
  return window.WIDGET_CONFIG
}

export function getWidgetContext() {
  if (typeof window === 'undefined' || !window.WIDGET_CONTEXT) {
    return { isPreview: false }
  }
  return window.WIDGET_CONTEXT
}

export function isPreviewMode(): boolean {
  return getWidgetContext().isPreview
}
